import { FC, useState } from "react";

import { IUser } from "@/models/User";
import Title from "antd/lib/typography/Title";
import { Alert, Button, Form, Input } from "antd";
import { UsersApi } from "@/api";
import { ERROR_500_MESSAGE } from "@/api/constants";

interface EditUserProps {
  user: IUser;
  onEdited?: (user: IUser) => void;
}

const EditUser: FC<EditUserProps> = ({ user, onEdited }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleFinish = async (values: { login: string; password: string }) => {
    try {
      setError("");
      setLoading(true);
      const newUser = await UsersApi.edit(user.userId, values);
      onEdited && onEdited(newUser);
    } catch (e: any) {
      setError(e.message || ERROR_500_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      requiredMark={false}
      name="login"
      initialValues={{ ...user }}
      onFinish={handleFinish}
    >
      <Form.Item>
        <Title level={4}>Edit user</Title>
      </Form.Item>
      <Form.Item
        label="Login"
        name="login"
        rules={[{ required: true, message: "Please input the login" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Password"
        name="password"
        rules={[{ required: true, message: "Please input the password" }]}
      >
        <Input />
      </Form.Item>

      {!!error && (
        <Form.Item>
          <Alert message={error} type="error" />
        </Form.Item>
      )}

      <Form.Item>
        <Button
          disabled={loading}
          loading={loading}
          type="primary"
          htmlType="submit"
        >
          Edit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default EditUser;
